import { render, staticRenderFns } from "./onlinebaseclassinfo.vue?vue&type=template&id=dbf9555c&scoped=true&"
import script from "./onlinebaseclassinfo.vue?vue&type=script&lang=js&"
export * from "./onlinebaseclassinfo.vue?vue&type=script&lang=js&"
import style0 from "./onlinebaseclassinfo.vue?vue&type=style&index=0&id=dbf9555c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf9555c",
  null
  
)

export default component.exports